<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" position fixed>
        <a-row>
              <a-col :xs="24" :sm="12">
                <a-form-item label="配送类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['isDelivery']" :trigger-change="true" dictCode="deliver" placeholder="请选择是否配送"/>
            </a-form-item>
              </a-col>

                <a-col :xs="24" :sm="12">
                  <a-form-item label="发货单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['orderCode']" placeholder="请输入发货单号"></a-input>
            </a-form-item>
                </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  
  import JDictSelectTag from "@/components/dict/JDictSelectTag"



  export default {
    name: "SalesOrderModal",
    components: { 
      JDate,
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"发货管理",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/sales/salesOrder/add",
          edit: "/sales/salesOrder/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'orderCode','channelOrderCode','isDelivery','deliveryAddress','consumerName','consumerPhone','orderCreatetime','orderPaytime','orderTotalprice','orderOriginalprice','orderUserprice','orderDeliveryprice','isOnsale','salePrice','saleContext','isCoupon','couponPrice','couponName','orderStoreid','orderStorecontact','orderStoreowner','orderState','relPublishids','orderChanner'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            
            that.$message.success("发货成功，同步到淘宝平台。");
            that.$emit('ok');
            that.confirmLoading = false;
            that.close();

          /*   httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            }) */
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'orderCode','channelOrderCode','isDelivery','deliveryAddress','consumerName','consumerPhone','orderCreatetime','orderPaytime','orderTotalprice','orderOriginalprice','orderUserprice','orderDeliveryprice','isOnsale','salePrice','saleContext','isCoupon','couponPrice','couponName','orderStoreid','orderStorecontact','orderStoreowner','orderState','relPublishids','orderChanner'))
      },

      
    }
  }
</script>